export default __webpack_public_path__ + "static/media/PS-DM.609a1b62.pdf";